module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ReserveButton/images/gold-disabled-hover-50.09609bf7.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ReserveButton/images/gold-disabled-hover-50.png
// module id = 3444
// module chunks = 11